
import Page from '@/Page.vue';
import { Component, Prop } from 'vue-property-decorator';
import { authStore } from '@/libs/auth/+store/store';
import { AuthGetter } from '@/libs/auth/models/auth-state';
import { PlanItemModel, ProcessTypeEnum, TenantUserModel } from '@/libs/Api';
import DashboardCardView from '@/libs/dashboard/components/DashboardCardView.vue';
import { planItemsStore } from '@/libs/plan-items/+state/store';
import { CrudGetter } from '@/libs/core/+state/models/crud-getter';
import { CrudAction } from '@/libs/core/+state/models/crud-action';
import { createAggregationQueryPayload } from '@/libs/core/+state/models/aggregation-query-payload';
import IssueSolvingItemSmall from '@/libs/issues-solving/components/IssueSolvingItemSmall.vue';
import moment from 'moment-timezone';

// Timezone pro zobrazování - vždy Praha bez ohledu na TZ prohlížeče
const DISPLAY_TIMEZONE = 'Europe/Prague';

import { createCrudQueryPayload } from '@/libs/core/+state/models/crud-query-payload';

@Component({
    components: {
        IssueSolvingItemSmall,
        DashboardCardView,
    },
})
export default class DashboardTodayIssueSolving extends Page {
    @Prop() tenantId!: string;
    protected tenantUser = authStore.useGetter(AuthGetter.GetTenantUser) as TenantUserModel;

    get donePlanItemsCount(): number {
        return planItemsStore.useGetter(CrudGetter.Count, 'DonePlanItemsCount') ?? 0;
    }

    get waitingPlanItemsCount(): number {
        return planItemsStore.useGetter(CrudGetter.Count, 'WaitingPlanItemsCount') ?? 0;
    }

    mounted() {
        this.loadDonePlanItemsCount();
        this.loadWaitingPlanItemsCount();
    }

    loadDonePlanItemsCount() {
        planItemsStore.dispatch(
            CrudAction.GetCount,
            createAggregationQueryPayload(
                [
                    {
                        field: 'isDeactivated',
                        op: 'eq',
                        comparand: false,
                    },
                    { field: 'time', op: 'gte', comparand: moment.tz(DISPLAY_TIMEZONE).add(-1, 'year').startOf('day').toDate() },
                    { field: 'time', op: 'lte', comparand: moment.tz(DISPLAY_TIMEZONE).endOf('day').toDate() },
                    { field: 'isAnswered', op: 'eq', comparand: true },
                    { field: 'processType', op: 'eq', comparand: ProcessTypeEnum.Audit },
                    { field: 'planItemAuditTenantUsers.tenantUserId', op: 'eq', comparand: this.tenantUser.id! },
                ],
                '',
                'DonePlanItemsCount'
            )
        );
    }

    loadWaitingPlanItemsCount() {
        planItemsStore.dispatch(
            CrudAction.GetCount,
            createAggregationQueryPayload(
                [
                    {
                        field: 'isDeactivated',
                        op: 'eq',
                        comparand: false,
                    },
                    { field: 'time', op: 'gte', comparand: moment.tz(DISPLAY_TIMEZONE).add(-1, 'year').startOf('day').toDate() },
                    { field: 'time', op: 'lte', comparand: moment.tz(DISPLAY_TIMEZONE).add(-1, 'days').endOf('day').toDate() },
                    { field: 'isAnswered', op: 'eq', comparand: false },
                    { field: 'processType', op: 'eq', comparand: ProcessTypeEnum.Audit },
                    { field: 'planItemAuditTenantUsers.tenantUserId', op: 'eq', comparand: this.tenantUser.id! },
                ],
                '',
                'WaitingPlanItemsCount'
            )
        );
    }
}
